var _path, _text, _text2, _text3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 778 371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M368 351.771H395.321V370.838H368z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76.449,
    y: 305.318,
    fill: "#ff009d",
    fontFamily: "'BebasKai', 'Bebas Kai', fantasy",
    fontSize: 368.483
  }, "\n        t\n        ", /*#__PURE__*/React.createElement("tspan", {
    x: "206.646px 349.371px 502.046px",
    y: "305.318px 305.318px 305.318px"
  }, "\n            eam\n        "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 67.974,
    y: 305.318,
    fill: "#00fff3",
    fontFamily: "'BebasKai', 'Bebas Kai', fantasy",
    fontSize: 368.483
  }, "\n        t\n        ", /*#__PURE__*/React.createElement("tspan", {
    x: "198.171px 340.896px 493.571px",
    y: "305.318px 305.318px 305.318px"
  }, "\n            eam\n        "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72.027,
    y: 305.318,
    fill: "#f99d1c",
    fontFamily: "'BebasKai', 'Bebas Kai', fantasy",
    fontSize: 368.483
  }, "\n        t\n        ", /*#__PURE__*/React.createElement("tspan", {
    x: "202.224px 344.95px 497.624px",
    y: "305.318px 305.318px 305.318px"
  }, "\n            eam\n        "))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M77.483 125.737H93.875V155.791H77.483z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M517.117 317.717H531.675V332.275H517.117z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M0 175.925H17.758V193.68300000000002H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M728.542 191.225H739.3670000000001V196.688H728.542z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M723.65 19.912H753.562V36.304H723.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M296.967 351.771H368V370.838H296.967z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M739.371 191.225H777.621V196.688H739.371z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M667.517 326.004H697.571V347.862H667.517z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M753.562 19.912H761.758V36.304H753.562z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M94.462 325.004H135.441V352.32500000000005H94.462z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M469.15 7.187H501.933V19.916H469.15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M186.1 0H251.671V13.663H186.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTeam);
export default __webpack_public_path__ + "static/media/text-team.bbae77c8d7c991e839d6f46ec60596eb.svg";
export { ForwardRef as ReactComponent };